<div (onSVGInserted)="handleSVG($event)" [inlineSVG]="'/assets/logos/' + getLogoFile(distributionChannel, country) + '.svg'"
     aria-label="ucs-icon"
     class="icon d-inline-flex {{class}} {{getAdditionalClasses()}}">
</div>
